import * as tslib_1 from "tslib";
import { OnInit, AfterViewInit, } from "@angular/core";
import { environment } from "src/environments/environment";
import * as $ from "jquery";
import offside from "offside-js";
import { isPlatformBrowser } from "@angular/common";
export class NavComponent {
    // NavSelectedLang: string;
    // MySelectedLang: string;
    constructor(app, formDataService, rest, eventEmitterService, countInCart, router, activatedRoute, platformId) {
        this.app = app;
        this.formDataService = formDataService;
        this.rest = rest;
        this.eventEmitterService = eventEmitterService;
        this.countInCart = countInCart;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.countCart = 0;
        this.haveToken = false;
        this.agentToken = false;
        this.showFoundApp = false;
        // this.MySelectedLang = app.SelectedLang;
        // this.button_lang = app.SelectedLang;
        // this.NavSelectedLang = app.SelectedLang;
        this.button_lang = app.SelectedLang;
        this.isBrowser = isPlatformBrowser(platformId);
    }
    switchLanguage(language) {
        // this.NavSelectedLang = language;
        // this.MySelectedLang = language;
        this.button_lang = language;
        this.app.switchLanguage(language);
        if (this.router.url === "/term") {
            this.TermConditionsComponentFunction(language);
        }
        else if (this.router.url === "/faq") {
            this.FAQComponentFunction(language);
        }
        else if (this.router.url === "/info") {
            this.InfoComponentFunction(language);
        }
        else if (this.router.url === "/about") {
            this.AboutComponentFunction(language);
        }
        else if (this.activatedRoute.snapshot.url[0].path === "article") {
            this.ArticleComponentFunction(language);
        }
    }
    ngOnInit() {
        this.getLanguage();
        if (this.isBrowser) {
            if (localStorage.getItem("previousData") !== null &&
                localStorage.getItem("localAuthenInfo") !== null) {
                this.showFoundApp = true;
            }
            this.person = this.formDataService.getFormData();
            try {
                const rawLocal = localStorage.getItem(environment.localAuthenInfo);
                if (rawLocal && rawLocal !== "undefined" && rawLocal !== "null") {
                    const authInfo = JSON.parse(rawLocal);
                    if (authInfo && authInfo.token) {
                        this.haveToken = true;
                        this.getCountCart();
                    }
                }
            }
            catch (e) {
                console.warn("Failed to parse localAuthenInfo in nav:", e);
            }
            // Check agent login
            try {
                const rawAgent = localStorage.getItem(environment.agentAuthenInfo);
                if (rawAgent && rawAgent !== "undefined" && rawAgent !== "null") {
                    const authInfo = JSON.parse(rawAgent);
                    if (authInfo && authInfo.token) {
                        this.agentToken = true;
                    }
                }
            }
            catch (e) {
                console.warn("Failed to parse agentAuthenInfo in nav:", e);
            }
            offside(".navbar-menu-mobile-wrapper", {
                buttonsSelector: ".navbar-menu-toggle",
                slidingSide: "right",
            });
        }
        // THIS MAKE INPUT CLICKABLE ON MOBILE
        function toggleInputClickableIfOverlayByLogo(width) {
            const logoEle = $(".navbar-evisa-logo");
            if (width >= 1800) {
                logoEle.removeClass("child-clickable");
            }
            else {
                logoEle.addClass("child-clickable");
            }
        }
        if (this.router.url === "/application" ||
            this.router.url.split("/")[1] === "edit-application") {
            $(document).ready(function () {
                return tslib_1.__awaiter(this, void 0, void 0, function* () {
                    toggleInputClickableIfOverlayByLogo($(this.window).width());
                });
            });
        }
        if (this.router.url === "/application" ||
            this.router.url.split("/")[1] === "edit-application") {
            $(window).on("resize", function () {
                toggleInputClickableIfOverlayByLogo($(this).width());
            });
        }
    }
    ngAfterViewInit() { }
    getCountCart() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.countInCart.funcCountCart();
        });
    }
    TermConditionsComponentFunction(language) {
        this.eventEmitterService.onTermConditionComponentButtonClick(language);
    }
    FAQComponentFunction(language) {
        this.eventEmitterService.onFAQComponentButtonClick(language);
    }
    InfoComponentFunction(language) {
        this.eventEmitterService.onInfoComponentButtonClick(language);
    }
    AboutComponentFunction(language) {
        this.eventEmitterService.onAboutComponentButtonClick(language);
    }
    ArticleComponentFunction(language) {
        this.eventEmitterService.onArticleComponentButtonClick(language);
    }
    getLanguage() {
        this.rest.getLanguage().subscribe((result) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.mLanguage = yield result;
        }));
    }
    goIndex() {
        // offside('.navbar-menu-mobile-wrapper', {
        //   buttonsSelector: '.navbar-menu-toggle',
        //   slidingSide: 'right'
        // });
        this.router.navigate(["/index"], { replaceUrl: true });
    }
    logout() {
        localStorage.removeItem(environment.localAuthenInfo);
        localStorage.removeItem(environment.agentAuthenInfo);
        localStorage.removeItem("confirm");
        this.agentToken = false;
        this.router.navigate(["/login"]);
    }
}
